/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatesNumberSuggestionResult,
    BatesNumberSuggestionResultFromJSON,
    BatesNumberSuggestionResultToJSON,
    BatesZipView,
    BatesZipViewFromJSON,
    BatesZipViewToJSON,
    HideCaseFileUpdate,
    HideCaseFileUpdateFromJSON,
    HideCaseFileUpdateToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProductionSetCreate,
    ProductionSetCreateFromJSON,
    ProductionSetCreateToJSON,
    ProductionSetUpdate,
    ProductionSetUpdateFromJSON,
    ProductionSetUpdateToJSON,
    ProductionSetView,
    ProductionSetViewFromJSON,
    ProductionSetViewToJSON,
} from '../models';

export interface ProductionSetCreateRequest {
    productionSetCreate?: ProductionSetCreate;
}

export interface ProductionSetDownloadProductionSetRequest {
    setId: string;
}

export interface ProductionSetGetRequest {
    setId: string;
}

export interface ProductionSetGetForCaseRequest {
    caseId: string;
}

export interface ProductionSetGetForDocumentRequest {
    documentId: string;
    limit?: number;
}

export interface ProductionSetGetSuggestedBatesStartForDocumentRequest {
    documentId: string;
}

export interface ProductionSetHideCaseFileRequest {
    setId: string;
    hideCaseFileUpdate: HideCaseFileUpdate;
}

export interface ProductionSetPollZipTaskRequest {
    setId: string;
    jobId: string;
}

export interface ProductionSetRestoreArchivedForDocumentRequest {
    documentId: string;
}

export interface ProductionSetStartZipTaskRequest {
    setId: string;
}

export interface ProductionSetUpdateRequest {
    setId: string;
    productionSetUpdate?: ProductionSetUpdate;
}

/**
 * 
 */
export class ProductionSetApi extends runtime.BaseAPI {

    /**
     */
    async productionSetCreateRaw(requestParameters: ProductionSetCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProductionSetView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductionSetCreateToJSON(requestParameters.productionSetCreate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductionSetViewFromJSON(jsonValue));
    }

    /**
     */
    async productionSetCreate(requestParameters: ProductionSetCreateRequest, initOverrides?: RequestInit): Promise<ProductionSetView> {
        const response = await this.productionSetCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetDownloadProductionSetRaw(requestParameters: ProductionSetDownloadProductionSetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetDownloadProductionSet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}/download`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async productionSetDownloadProductionSet(requestParameters: ProductionSetDownloadProductionSetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.productionSetDownloadProductionSetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetGetRaw(requestParameters: ProductionSetGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProductionSetView>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductionSetViewFromJSON(jsonValue));
    }

    /**
     */
    async productionSetGet(requestParameters: ProductionSetGetRequest, initOverrides?: RequestInit): Promise<ProductionSetView> {
        const response = await this.productionSetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetGetForCaseRaw(requestParameters: ProductionSetGetForCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ProductionSetView>>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling productionSetGetForCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/case/{caseId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductionSetViewFromJSON));
    }

    /**
     */
    async productionSetGetForCase(requestParameters: ProductionSetGetForCaseRequest, initOverrides?: RequestInit): Promise<Array<ProductionSetView>> {
        const response = await this.productionSetGetForCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetGetForDocumentRaw(requestParameters: ProductionSetGetForDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ProductionSetView>>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling productionSetGetForDocument.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/document/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductionSetViewFromJSON));
    }

    /**
     */
    async productionSetGetForDocument(requestParameters: ProductionSetGetForDocumentRequest, initOverrides?: RequestInit): Promise<Array<ProductionSetView>> {
        const response = await this.productionSetGetForDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetGetSuggestedBatesStartForDocumentRaw(requestParameters: ProductionSetGetSuggestedBatesStartForDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BatesNumberSuggestionResult>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling productionSetGetSuggestedBatesStartForDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/document/{documentId}/suggested`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatesNumberSuggestionResultFromJSON(jsonValue));
    }

    /**
     */
    async productionSetGetSuggestedBatesStartForDocument(requestParameters: ProductionSetGetSuggestedBatesStartForDocumentRequest, initOverrides?: RequestInit): Promise<BatesNumberSuggestionResult> {
        const response = await this.productionSetGetSuggestedBatesStartForDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetHideCaseFileRaw(requestParameters: ProductionSetHideCaseFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetHideCaseFile.');
        }

        if (requestParameters.hideCaseFileUpdate === null || requestParameters.hideCaseFileUpdate === undefined) {
            throw new runtime.RequiredError('hideCaseFileUpdate','Required parameter requestParameters.hideCaseFileUpdate was null or undefined when calling productionSetHideCaseFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}/hide-case-file`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HideCaseFileUpdateToJSON(requestParameters.hideCaseFileUpdate),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productionSetHideCaseFile(requestParameters: ProductionSetHideCaseFileRequest, initOverrides?: RequestInit): Promise<void> {
        await this.productionSetHideCaseFileRaw(requestParameters, initOverrides);
    }

    /**
     */
    async productionSetPollZipTaskRaw(requestParameters: ProductionSetPollZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BatesZipView>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetPollZipTask.');
        }

        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling productionSetPollZipTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}/bates-zip-job/{jobId}`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))).replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatesZipViewFromJSON(jsonValue));
    }

    /**
     */
    async productionSetPollZipTask(requestParameters: ProductionSetPollZipTaskRequest, initOverrides?: RequestInit): Promise<BatesZipView> {
        const response = await this.productionSetPollZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetRestoreArchivedForDocumentRaw(requestParameters: ProductionSetRestoreArchivedForDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling productionSetRestoreArchivedForDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/document/{documentId}/restore-archived`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productionSetRestoreArchivedForDocument(requestParameters: ProductionSetRestoreArchivedForDocumentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.productionSetRestoreArchivedForDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async productionSetStartZipTaskRaw(requestParameters: ProductionSetStartZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BatesZipView>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetStartZipTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}/bates-zip-job`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatesZipViewFromJSON(jsonValue));
    }

    /**
     */
    async productionSetStartZipTask(requestParameters: ProductionSetStartZipTaskRequest, initOverrides?: RequestInit): Promise<BatesZipView> {
        const response = await this.productionSetStartZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productionSetUpdateRaw(requestParameters: ProductionSetUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.setId === null || requestParameters.setId === undefined) {
            throw new runtime.RequiredError('setId','Required parameter requestParameters.setId was null or undefined when calling productionSetUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProductionSet/{setId}`.replace(`{${"setId"}}`, encodeURIComponent(String(requestParameters.setId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProductionSetUpdateToJSON(requestParameters.productionSetUpdate),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async productionSetUpdate(requestParameters: ProductionSetUpdateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.productionSetUpdateRaw(requestParameters, initOverrides);
    }

}
